function nl2brFilter() {
    'ngInject';

    return function (str) {
        if (str) {
            // replace new lines with <br/> tags for multiline display in HTML
            return str.replace(/\n/g, '<br/>');
        }
    };
}

angular
    .module('BB')
    .filter('nl2br', nl2brFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/nl2br.filter.js